// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "7ae0e69a",
    "hash": "7ae0e69a",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "7ae0e69a",
    "semverString": null,
    "version": "2026.9.0.13"
};
/* tslint:enable */
